module.exports = __webpack_public_path__ + "img/bumaga-i-prisposoblenija-dlja-cherchenija.84bb3f96.svg";